import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ApiService, EnvironmentModel} from '@cas-hub/acabim-common-client';
import {GenericPairsResponse} from '../_models/generic.model';

@Injectable({
    providedIn: 'root'
})
export class ContactOrganisationsService extends ApiService {

    constructor(protected client: HttpClient, protected environment: EnvironmentModel) {
        super(client, environment);
    }

    protected controller = 'contact/entity';

    /**
     * Retrieve all available CAS roles
     * @returns An array of CAS roles
     */
    public getContactOrganisations(): Observable<GenericPairsResponse> {
        return this.client.get(this.url('', false), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(
            map(data => ({
            count: (data as GenericPairsResponse).count,
            data: (data as GenericPairsResponse).data
        })));
    }

    /**
     * Retrieve all available members
     * @returns An array of members
     */
    public getNonMembers(organisationId: number): Observable<GenericPairsResponse> {
        let params = new HttpParams();
        params.set('notMemberOf', organisationId.toString());
        return this.client.get(this.url('contact/list', true), {
            params,
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(
            map(data => ({
                count: (data as GenericPairsResponse).count,
                data: (data as GenericPairsResponse).data
            })));
    }


    /**
     * Retrieve all available members
     * @returns An array of members
     */
    public getPossibleMembers(): Observable<GenericPairsResponse> {
        return this.client.get(this.url('contact/list?notMember=1', true), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(
            map(data => ({
                count: (data as GenericPairsResponse).count,
                data: (data as GenericPairsResponse).data
            })));
    }

}
